import { forwardRef } from 'react'
import { cx } from './utils.js'

// Button (migrated off Tailwind in Wave 47u — was missed in the
// original 47q sweep). Variants and sizes are now studio CSS class
// modifiers; styles live under .studio-button in studio.css.
//
// Premium-SaaS refinement (2026-06-10): Vercel-crisp design with
// clean 1px borders, subtle fills on secondary, cast-metal ember
// on primary, clear focus rings, 120ms hover states.
//
// Variants: primary | outline | ghost | danger | teal | blue
// Sizes:    sm | md | lg

export const Button = forwardRef(function Button(
  {
    as: Component = 'button',
    variant = 'outline',
    size = 'md',
    className,
    type,
    disabled,
    onClick,
    ...props
  },
  ref
) {
  const isNativeButton = Component === 'button'
  const resolvedType = isNativeButton ? type || 'button' : type
  // Non-button roots (e.g. <a>) cannot use the `disabled` attribute without
  // breaking HTML semantics, so downgrade to aria-disabled and swallow clicks.
  const guardedClick = (event) => {
    if (disabled && !isNativeButton) {
      event.preventDefault()
      event.stopPropagation()
      return
    }
    if (onClick) onClick(event)
  }
  return (
    <Component
      ref={ref}
      type={resolvedType}
      disabled={isNativeButton ? disabled : undefined}
      aria-disabled={!isNativeButton && disabled ? 'true' : undefined}
      tabIndex={!isNativeButton && disabled ? -1 : props.tabIndex}
      onClick={guardedClick}
      className={cx(
        'studio-button',
        `size-${size}`,
        `variant-${variant}`,
        className
      )}
      {...props}
    />
  )
})
